export default {
  id: 'receipts',
  title: 'Računi',
  icon: 'mdi-receipt-text',
  show: true,
  order: 10,
  children: [
    {
      id: 'receipts-overview',
      title: 'Pregled svih računa',
      icon: 'mdi-view-list',
      show: true,
      order: 1,
      content: () => `
        <h2 id="receipts">Pregled svih računa</h2>
        <p>
          Modul računa omogućava pregled svih izdanih računa, filtriranje, pretragu
          i detaljni uvid u pojedinačne račune sa svim fiskalnim podacima.
        </p>

        <h3 class="mt-4">Pristup modulu</h3>
        <ol>
          <li>U lijevom meniju kliknite na <strong>"Računi"</strong></li>
          <li>Prikazuje se lista svih računa</li>
        </ol>

        <h3 class="mt-4">Podaci prikazani u tablici</h3>
        <table class="info-table">
          <thead>
            <tr>
              <th>Stupac</th>
              <th>Opis</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Broj računa</strong></td>
              <td>Jedinstveni broj računa (npr. 1234/1/2025)</td>
            </tr>
            <tr>
              <td><strong>Datum i vrijeme</strong></td>
              <td>Kada je račun izdan</td>
            </tr>
            <tr>
              <td><strong>Blagajna</strong></td>
              <td>Na kojoj blagajni je izdan</td>
            </tr>
            <tr>
              <td><strong>Operator</strong></td>
              <td>Korisnik koji je izdao račun</td>
            </tr>
            <tr>
              <td><strong>Klijent</strong></td>
              <td>Ime klijenta (ako je naveden)</td>
            </tr>
            <tr>
              <td><strong>Iznos</strong></td>
              <td>Ukupan iznos računa</td>
            </tr>
            <tr>
              <td><strong>Način plaćanja</strong></td>
              <td>Gotovina, Kartica, Transakcijski račun</td>
            </tr>
            <tr>
              <td><strong>Status</strong></td>
              <td>Fiskalizirano, Stornirano, Greška</td>
            </tr>
            <tr>
              <td><strong>JIR</strong></td>
              <td>Jedinstveni identifikator računa (FINA)</td>
            </tr>
          </tbody>
        </table>

        <h3 class="mt-4">Statusi računa</h3>
        <ul>
          <li><span class="status-chip green">FISKALIZIRANO</span> - Račun uspješno fiskaliziran</li>
          <li><span class="status-chip orange">PENDING</span> - Račun čeka fiskalizaciju</li>
          <li><span class="status-chip red">GREŠKA</span> - Greška pri fiskalizaciji</li>
          <li><span class="status-chip red">STORNIRANO</span> - Račun je storniran</li>
          <li><span class="status-chip grey">DRAFT</span> - Račun u izradi (nije fiskaliziran)</li>
        </ul>

        <div class="info-box">
          <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>JIR (Jedinstveni Identifikator Računa):</strong> Svaki fiskalizirani račun dobiva JIR od FIN-e kao potvrdu valjanosti.
          </div>
        </div>

        <h3 class="mt-4">Filtriranje i pretraga</h3>
        <p>Možete filtrirati račune po:</p>
        <ul>
          <li><strong>Datum</strong> - Odaberite razdoblje (danas, ovaj tjedan, ovaj mjesec, prilagođeno)</li>
          <li><strong>Blagajna</strong> - Filtrirajte po određenoj blagajni</li>
          <li><strong>Operator</strong> - Filtrirajte po korisniku koji je izdao račun</li>
          <li><strong>Način plaćanja</strong> - Gotovina, Kartica, itd.</li>
          <li><strong>Status</strong> - Fiskalizirano, Stornirano, itd.</li>
          <li><strong>Klijent</strong> - Pretraga po imenu klijenta</li>
        </ul>

        <div class="success-box">
          <i class="mdi mdi-lightbulb" style="color: #4CAF50; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Brza pretraga:</strong> Koristite polje za pretragu da pronađete račun po broju, JIR-u ili imenu klijenta.
          </div>
        </div>

        <h3 class="mt-4">Akcije nad računom</h3>
        <p>Za svaki račun dostupne su sljedeće akcije:</p>
        <ul>
          <li><i class="mdi mdi-eye"></i> <strong>Pregledaj</strong> - Detaljan prikaz računa</li>
          <li><i class="mdi mdi-printer"></i> <strong>Ispis</strong> - Ponovno ispisivanje računa</li>
          <li><i class="mdi mdi-email"></i> <strong>Pošalji email</strong> - Slanje računa klijentu</li>
          <li><i class="mdi mdi-download"></i> <strong>PDF</strong> - Download računa kao PDF</li>
          <li><i class="mdi mdi-delete"></i> <strong>Storniraj</strong> - Storniranje računa (samo za fiskalizirane)</li>
        </ul>

        <div class="warning-box">
          <i class="mdi mdi-alert" style="color: #FF9800; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Storniranje:</strong> Stornirani račun se ne može povratiti! Proces storniranja također šalje zahtjev FIN-i.
          </div>
        </div>

        <h3 class="mt-4">Izvoz podataka</h3>
        <p>Možete izvesti listu računa u:</p>
        <ul>
          <li><strong>Excel (.xlsx)</strong> - Za daljnju analizu</li>
          <li><strong>CSV (.csv)</strong> - Za import u druge sustave</li>
          <li><strong>PDF</strong> - Za ispis ili arhiviranje</li>
        </ul>

        <h2 id="tips" class="mt-6">Savjeti</h2>
        <ul>
          <li><strong>Redovna provjera</strong> - Provjeravajte statusefiskalizacije redovno</li>
          <li><strong>Arhiviranje</strong> - Izvozite račune mjesečno za backup</li>
          <li><strong>Greške</strong> - Odmah reagirajte na račune sa statusom GREŠKA</li>
        </ul>
      `
    },
    {
      id: 'receipts-filtering',
      title: 'Filtriranje računa',
      icon: 'mdi-filter',
      show: true,
      order: 2,
      content: () => `
        <h2 id="filtering">Filtriranje računa</h2>
        <p>
          Sustav za filtriranje omogućava brzo pronalaženje specifičnih računa
          među tisućama izdanih računa.
        </p>

        <h3 class="mt-4">Osnovni filteri</h3>
        <table class="info-table">
          <thead>
            <tr>
              <th>Filter</th>
              <th>Opis</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Datum</strong></td>
              <td>Odaberite razdoblje ili raspon datuma</td>
            </tr>
            <tr>
              <td><strong>Broj računa</strong></td>
              <td>Pretraživanje po broju računa</td>
            </tr>
            <tr>
              <td><strong>JIR</strong></td>
              <td>Pretraživanje po JIR broju</td>
            </tr>
            <tr>
              <td><strong>Klijent</strong></td>
              <td>Filtriraj po imenu/nazivu klijenta ili OIB-u</td>
            </tr>
            <tr>
              <td><strong>Blagajna</strong></td>
              <td>Filtriraj po određenoj blagajni</td>
            </tr>
            <tr>
              <td><strong>Operator</strong></td>
              <td>Filtriraj po korisniku koji je izdao račun</td>
            </tr>
          </tbody>
        </table>

        <h3 class="mt-4">Napredni filteri</h3>
        <ul>
          <li><strong>Status</strong> - Fiskalizirano, Stornirano, Greška, Draft</li>
          <li><strong>Način plaćanja</strong> - Gotovina, Kartica, Transakcijski račun</li>
          <li><strong>Valuta</strong> - EUR, USD, HRK, itd.</li>
          <li><strong>Iznos</strong> - Od/Do određenog iznosa</li>
          <li><strong>Tip računa</strong> - R1 (fizičke osobe) ili R2 (pravne osobe)</li>
        </ul>

        <div class="info-box">
          <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Brza pretraga:</strong> Unesite bilo koji podatak (broj računa, JIR, ime klijenta) u glavno polje za pretragu, sustav će automatski pretraživati po svim poljima.
          </div>
        </div>

        <h3 class="mt-4">Spremanje filtera</h3>
        <p>Često korištene filtere možete spremiti:</p>
        <ol>
          <li>Postavite željene filtere</li>
          <li>Kliknite <strong>"Spremi filter"</strong></li>
          <li>Unesite naziv (npr. "Dnevni promet gotovinom")</li>
          <li>Filter je sada dostupan u "Spremljeni filteri"</li>
        </ol>

        <h3 class="mt-4">Primjeri korištenja</h3>

        <h4 class="mt-3">Pronalaženje svih računa određenog klijenta</h4>
        <ol>
          <li>Filter: <strong>Klijent</strong> = "Ivan Horvat" ili OIB "12345678901"</li>
          <li>Opcionalno: Postavi datum od/do</li>
          <li>Kliknite <strong>"Primijeni"</strong></li>
        </ol>

        <h4 class="mt-3">Provjera računa sa greškom</h4>
        <ol>
          <li>Filter: <strong>Status</strong> = "Greška"</li>
          <li>Dobivate listu svih računa koji nisu uspješno fiskalizirani</li>
        </ol>

        <h4 class="mt-3">Izvještaj za određenog operatora</h4>
        <ol>
          <li>Filter: <strong>Operator</strong> = "Ana Marić"</li>
          <li>Datum: Ovaj mjesec</li>
          <li>Vidite sve račune koje je Ana izdala</li>
        </ol>

        <div class="success-box">
          <i class="mdi mdi-lightbulb" style="color: #4CAF50; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Savjet:</strong> Kombinirajte više filtera za preciznije rezultate. Npr. "Gotovina + Danas + Blagajna 1" za brzi dnevni izvještaj.
          </div>
        </div>

        <h2 id="tips" class="mt-6">Savjeti</h2>
        <ul>
          <li><strong>Očisti filtere</strong> - Kliknite "Očisti sve" da resetirate filtere</li>
          <li><strong>Izvoz rezultata</strong> - Nakon filtriranja, možete izvesti rezultate u Excel/CSV</li>
          <li><strong>Brza pretraga</strong> - Za brzo pronalaženje pojedinačnog računa, koristite samo glavno polje za pretragu</li>
        </ul>
      `
    },
    {
      id: 'receipts-details',
      title: 'Detaljni pregled računa',
      icon: 'mdi-file-document-outline',
      show: true,
      order: 3,
      content: () => `
        <h2 id="details">Detaljni pregled računa</h2>
        <p>
          Detaljni prikaz računa omogućava uvid u sve podatke o pojedinačnom računu,
          uključujući fiskalne podatke, artikle, načine plaćanja i povijest.
        </p>

        <h3 class="mt-4">Pristup detaljnom prikazu</h3>
        <ol>
          <li>Idite na <strong>"Računi"</strong></li>
          <li>Pronađite račun u listi</li>
          <li>Kliknite <i class="mdi mdi-eye"></i> <strong>"Pregledaj"</strong> ili dvostruki klik na redak</li>
        </ol>

        <h3 class="mt-4">Osnovne informacije</h3>
        <table class="info-table">
          <thead>
            <tr>
              <th>Podatak</th>
              <th>Opis</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Broj računa</strong></td>
              <td>Jedinstveni interni broj (npr. 1234/1/2025)</td>
            </tr>
            <tr>
              <td><strong>Datum i vrijeme</strong></td>
              <td>Kada je račun izdan</td>
            </tr>
            <tr>
              <td><strong>Status</strong></td>
              <td>Fiskalizirano, Stornirano, Greška, Draft</td>
            </tr>
            <tr>
              <td><strong>Blagajna</strong></td>
              <td>Naziv blagajne</td>
            </tr>
            <tr>
              <td><strong>Operator</strong></td>
              <td>Korisnik koji je izdao račun</td>
            </tr>
          </tbody>
        </table>

        <h3 class="mt-4">Fiskalni podaci</h3>
        <table class="info-table">
          <thead>
            <tr>
              <th>Podatak</th>
              <th>Opis</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>JIR</strong></td>
              <td>Jedinstveni Identifikator Računa od FIN-e</td>
            </tr>
            <tr>
              <td><strong>ZKI</strong></td>
              <td>Zaštitni Kod Izdavatelja</td>
            </tr>
            <tr>
              <td><strong>Vrijeme fiskalizacije</strong></td>
              <td>Kada je račun fiskaliziran kod FIN-e</td>
            </tr>
            <tr>
              <td><strong>QR kod</strong></td>
              <td>QR kod za provjeru računa na porezna.gov.hr</td>
            </tr>
          </tbody>
        </table>

        <div class="info-box">
          <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>JIR provjera:</strong> Kopirajte JIR broj i provjerite ga na web stranici Porezne uprave za potvrdu valjanosti računa.
          </div>
        </div>

        <h3 class="mt-4">Artikli na računu</h3>
        <p>Tablica sa svim artiklima:</p>
        <table class="info-table">
          <thead>
            <tr>
              <th>Artikl</th>
              <th>Količina</th>
              <th>Cijena</th>
              <th>PDV %</th>
              <th>Ukupno</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Coca Cola 0.33L</td>
              <td>2</td>
              <td>2.50 €</td>
              <td>25%</td>
              <td>5.00 €</td>
            </tr>
            <tr>
              <td>Cappuccino</td>
              <td>1</td>
              <td>3.00 €</td>
              <td>13%</td>
              <td>3.00 €</td>
            </tr>
          </tbody>
        </table>

        <h3 class="mt-4">Plaćanje</h3>
        <ul>
          <li><strong>Način plaćanja</strong> - Gotovina, Kartica, Transakcijski račun</li>
          <li><strong>Primljeni iznos</strong> - Koliko je klijent platio</li>
          <li><strong>Povrat</strong> - Koliko je vraćeno (kod gotovine)</li>
          <li><strong>Valuta</strong> - EUR, USD, HRK, itd.</li>
        </ul>

        <h3 class="mt-4">Sažetak PDV-a</h3>
        <table class="info-table">
          <thead>
            <tr>
              <th>PDV stopa</th>
              <th>Osnovica</th>
              <th>PDV iznos</th>
              <th>Ukupno</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>25%</td>
              <td>4.00 €</td>
              <td>1.00 €</td>
              <td>5.00 €</td>
            </tr>
            <tr>
              <td>13%</td>
              <td>2.65 €</td>
              <td>0.35 €</td>
              <td>3.00 €</td>
            </tr>
            <tr>
              <td><strong>UKUPNO</strong></td>
              <td><strong>6.65 €</strong></td>
              <td><strong>1.35 €</strong></td>
              <td><strong>8.00 €</strong></td>
            </tr>
          </tbody>
        </table>

        <h3 class="mt-4">Klijent (ako je naveden)</h3>
        <ul>
          <li><strong>Naziv/Ime</strong></li>
          <li><strong>OIB</strong></li>
          <li><strong>Adresa</strong></li>
          <li><strong>Tip računa</strong> - R1 ili R2</li>
        </ul>

        <h3 class="mt-4">Akcije</h3>
        <p>Iz detaljnog prikaza možete:</p>
        <ul>
          <li><i class="mdi mdi-printer"></i> <strong>Ispiši</strong> - Ponovno ispisivanje računa</li>
          <li><i class="mdi mdi-download"></i> <strong>PDF</strong> - Download računa kao PDF</li>
          <li><i class="mdi mdi-email"></i> <strong>Pošalji email</strong> - Slanje računa klijentu</li>
          <li><i class="mdi mdi-delete"></i> <strong>Storniraj</strong> - Storniranje računa (samo fiskalizirani)</li>
          <li><i class="mdi mdi-content-copy"></i> <strong>Kopiraj</strong> - Kreiranje novog računa sa istim artiklima</li>
        </ul>

        <div class="warning-box">
          <i class="mdi mdi-alert" style="color: #FF9800; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Storniranje:</strong> Storniranje je nepovratna akcija! Stornirani račun ne može biti vraćen, a fiskalni podaci se šalju FINA-i.
          </div>
        </div>

        <h3 class="mt-4">Povijest izmjena</h3>
        <p>Na dnu prikaza vidite povijest:</p>
        <ul>
          <li>Kada je račun kreiran</li>
          <li>Kada je fiskaliziran</li>
          <li>Eventualne izmjene ili pokušaji storniranja</li>
        </ul>

        <div class="success-box">
          <i class="mdi mdi-lightbulb" style="color: #4CAF50; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Savjet:</strong> Koristite funkciju "Kopiraj račun" kada klijent naručuje iste artikle više puta - uštedit ćete vrijeme.
          </div>
        </div>
      `
    },
    {
      id: 'receipts-statuses',
      title: 'Statusi računa',
      icon: 'mdi-information',
      show: true,
      order: 4,
      content: () => `
        <h2>Statusi računa</h2>
        <p>Svaki račun u AI Kasa sustavu ima određeni status.</p>

        <h3 class="mt-4">Statusi</h3>
        <table class="info-table">
          <thead>
            <tr>
              <th>Status</th>
              <th>Značenje</th>
              <th>Akcija</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><span class="status-chip success">PAID</span></td>
              <td>Račun je plaćen i fiskaliziran</td>
              <td>Račun je završen</td>
            </tr>
            <tr>
              <td><span class="status-chip warning">PENDING</span></td>
              <td>Račun čeka na plaćanje</td>
              <td>Potrebno platiti račun</td>
            </tr>
            <tr>
              <td><span class="status-chip error">OVERDUE</span></td>
              <td>Prekoračen rok plaćanja</td>
              <td>Hitno kontaktirati klijenta</td>
            </tr>
            <tr>
              <td><span class="status-chip error">FAILED</span></td>
              <td>Fiskalizacija neuspješna</td>
              <td>Pokušati ponovno fiskalizirati</td>
            </tr>
            <tr>
              <td><span class="status-chip grey">CANCELLED</span></td>
              <td>Račun je storniran</td>
              <td>Račun je poništen</td>
            </tr>
            <tr>
              <td><span class="status-chip grey">REVERSED</span></td>
              <td>Povrat robe</td>
              <td>Račun povrata</td>
            </tr>
          </tbody>
        </table>
      `
    },
    {
      id: 'receipts-fiscalization',
      title: 'Fiskalizacija',
      icon: 'mdi-check-decagram',
      show: true,
      order: 5,
      content: () => `
        <h2>Fiskalizacija</h2>
        <p>Fiskalizacija je zakonska obaveza slanja podataka o računu u sustav Porezne uprave.</p>

        <h3 class="mt-4">Što je fiskalizacija?</h3>
        <p>
          Fiskalizacija je proces kojim se podaci o izdanom računu automatski šalju
          Poreznoj upravi u trenutku izdavanja. Nakon uspješne fiskalizacije, račun dobiva:
        </p>
        <ul>
          <li><strong>JIR (Jedinstveni identifikator računa):</strong> Jedinstveni broj koji dodjeljuje FINA</li>
          <li><strong>ZKI (Zaštitni kod izdavatelja):</strong> Kriptografski kod za zaštitu podataka</li>
          <li><strong>ZKI QR kod:</strong> QR kod koji sadrži ZKI i osnovne podatke računa</li>
        </ul>

        <h3 class="mt-4">Kada se fiskalizira?</h3>
        <p>Račun se fiskalizira automatski pri:</p>
        <ul>
          <li>Izdavanju gotovinskokog računa</li>
          <li>Zatvaranju stola (ugostiteljstvo)</li>
          <li>Završetku plaćanja</li>
        </ul>

        <div class="warning-box mt-4">
          <i class="mdi mdi-alert" style="color: #FF9800; margin-right: 8px; font-size: 20px;"></i>
          <strong>Važno:</strong> Za fiskalizaciju je potreban važeći FINA certifikat!
        </div>

        <h3 class="mt-4">Što ako fiskalizacija ne uspije?</h3>
        <p>Ako fiskalizacija ne uspije:</p>
        <ol>
          <li>Provjerite internetsku vezu</li>
          <li>Provjerite valjanost FINA certifikata</li>
          <li>Pokušajte ponovno fiskalizirati iz pregleda računa</li>
          <li>Kontaktirajte podršku ako problem perzistira</li>
        </ol>
      `
    }
  ]
}
